import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { invite } from '../../store/actions/authActions'

class Invite extends Component {
  state = {
    email: '',
    phone: '',
    firstName: '',
    lastName: '',
    trade: '',
  }
  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value
    })
  }
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.invite(this.state, this.props.companyName, this.props.projectName);
    this.props.history.push({pathname: '/users'});
  }
  render() {
    const { auth, authError } = this.props;
   
    return (
      <div className="container">
        <form className="white" onSubmit={this.handleSubmit}>
          <h5 className="grey-text text-darken-3">Invite A Member</h5>
          <div className="input-field">
            <label htmlFor="firstName">First Name</label>
            <input type="text" id='firstName' onChange={this.handleChange} />
          </div>
          <div className="input-field">
            <label htmlFor="lastName">Last Name</label>
            <input type="text" id='lastName' onChange={this.handleChange} />
          </div>
          <div className="input-field">
            <label htmlFor="email">Email</label>
            <input type="email" id='email' onChange={this.handleChange} />
          </div>
          <div className="input-field">
            <label htmlFor="password">Phone</label>
            <input type="text" id='phone' onChange={this.handleChange} />
          </div>
          
          <div className="input-field">
            <label htmlFor="lastName">Trade</label>
            <input type="text" id='trade' onChange={this.handleChange} />
          </div>
          <div className="input-field">
            <button className="btn green lighten-1 z-depth-0">Invite</button>
            <div className="center red-text">
              { authError ? <p>{authError}</p> : null }
            </div>
          </div>
        </form>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const projectName = ownProps.match.params.projectName;
  const companyName = ownProps.match.params.companyName;
  return {
    auth: state.firebase.auth,
    authError: state.auth.authError,
    projectName: ownProps.match.params.projectName,
    companyName: ownProps.match.params.companyName
  }
}

const mapDispatchToProps = (dispatch)=> {
  return {
    invite: (creds, companyName, projectName) => dispatch(invite(creds, companyName, projectName))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Invite)



// WEBPACK FOOTER //
// ./src/components/users/Invite.js